import React from "react";
import {
  Grid,
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import CountUp from "react-countup";

const StatCard = ({ item }) => (
  <Tooltip title={item.tooltip} arrow placement="top">
    <Card
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: 3,
        boxShadow: 3,
        height: 120,
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          sx={{
            bgcolor: item.bgColor,
            color: item.iconColor,
            borderRadius: "50%",
            width: 70,
            height: 70,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {item.icon}
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {item.label}
          </Typography>
          <Typography variant="h6" fontWeight="bold" fontSize={28}>
            <CountUp
              start={0}
              end={Number(item.value.toString().replace(/\s/g, ""))} // handle numbers with spaces
              duration={1.5}
              separator=" "
            />
          </Typography>
        </Box>
      </Box>
    </Card>
  </Tooltip>
);

const Teachers = ({ stats, loading, isError }) => {
  if (loading) return <CircularProgress />;
  if (isError) return <Alert severity="error">Failed to load teachers</Alert>;

  const data = [
    {
      label: "Total Teachers",
      value: stats?.totalTeachers || 0,
      icon: <SupervisorAccountIcon fontSize="large" />,
      iconColor: "#1976d2",
      bgColor: "#e3f2fd",
      tooltip: "Nombre total des enseignants",
    },
    {
      label: "Approved Teachers",
      value: stats?.approvedTeachers || 0,
      icon: <CheckCircleIcon fontSize="large" />,
      iconColor: "#2e7d32",
      bgColor: "#e8f5e9",
      tooltip: "Enseignants agréés",
    },
    {
      label: "Evaluator Teachers",
      value: stats?.evaluatorTeachers || 0,
      icon: <PersonSearchIcon fontSize="large" />,
      iconColor: "#0288d1",
      bgColor: "#e1f5fe",
      tooltip: "Enseignants évaluateurs",
    },
    {
      label: "Not Approved Teachers",
      value: stats?.notApprovedTeachers || 0,
      icon: <RemoveCircleIcon fontSize="large" />,
      iconColor: "#ed6c02",
      bgColor: "#fff3e0",
      tooltip: "Enseignant non agréé",
    },
  ];

  return (
    <Grid container spacing={2} mb={3}>
      {data.map((item, i) => (
        <Grid item xs={12} sm={6} md={2.4} key={i}>
          <StatCard item={item} />
        </Grid>
      ))}
    </Grid>
  );
};

export default Teachers;
